import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    id: 'app.containers.AIWorkflowBuilder.Chatbot.header',
    defaultMessage: 'Upload your file',
  },
});
